import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Box,
  Grid,
  Typography,
  Slide,
  Fade,
  Grow,
  CircularProgress,
} from "@mui/material";
import confetti from "canvas-confetti";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../../appStore";
import axios from "axios";
import { api_url } from "../../../apiUtils";
import { toast } from "react-toastify";
import { useTheme, useMediaQuery } from "@mui/material";
import { getDeviceId } from "../../utils/DeviceId";
import { pingGameSession } from "../../utils/GameServices";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const directions = [
  "North",
  "North-East",
  "East",
  "South-East",
  "South",
  "South-West",
  "West",
  "North-West",
];

const labelColors = [
  "#ff6b6b", // North
  "#6bc5ff", // South
  "#6bff95", // East
  "#ffd56b", // West
  "#d66bff", // North-East
  "#6bafff", // North-West
  "#ff6bf5", // South-East
  "#6bffdd", // South-West
];

const generateWheelData = () =>
  directions.map((dir, i) => ({
    option: dir,
    style: {
      backgroundColor: i % 2 === 0 ? "#0288d1" : "#26a69a",
      textColor: "#fff",
    },
  }));

const DirectionWheelGame = () => {
  const navigate = useNavigate();
  const [data] = useState(generateWheelData());
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [didWin, setDidWin] = useState(false);
  const [selectedDirection, setSelectedDirection] = useState("North");
  const [amount, setAmount] = useState(7);
  const [disabled, setDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [resultData, setResultData] = useState(null);
  const {
    setWalletBalance,
    profileData,
    directionTimerId,
    directionMinute,
    directionTimerStartedAt,
    setDirectionMinute,
    setDirectionTimerId,
    setDirectionTimerStartedAt,
  } = useAppStore();
  const [spinPhase, setSpinPhase] = useState("fast");
  const [rotationDeg, setRotationDeg] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [showSpinButton, setShowSpinButton] = useState(true);
  const [gameSettings, setGameSettings] = useState({
    dice: { forcedWinCycleCount: null, winningRatio: null },
    spin: { forcedWinCycleCount: null, winningRatio: null },
    direction: { forcedWinCycleCount: null, winningRatio: null },
  });
  const [loadingResult, setLoadingResult] = useState(false);
  const deviceId = getDeviceId();
  const sessionToken = sessionStorage.getItem("sessionId");

  // inside your component:
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const circleSize = isSmall ? 320 : 400; // matches width/height of <Box>
  const center = circleSize / 2;
  const radius = center - 30; // gives margin from the edge
  const paddingValue = circleSize * 0.05; // e.g., 5% of circle size (~16px on 320, ~22px on 450)
  const usableSize = circleSize - paddingValue * 2;
  const labelRadius = center - usableSize * 0.1; // still 10% inward from new edge

  const handleSpin = (finalPrizeIndex) => {
    const fastSpins = 360 * 6; // 6 full spins
    const finalRotation =
      (360 / directions.length) * finalPrizeIndex + fastSpins;

    setSpinPhase("final");
    setRotationDeg(finalRotation);
  };

  const getPrizeIndexFromDirection = (direction) => {
    return data.findIndex((item) => item.option === direction);
  };

  const handleSpinClick = async () => {
    setLoadingResult(true); // show loader when spin starts
    if (!selectedDirection || !amount) {
      toast.warning("Please select a direction and enter an amount!");
      return;
    }
    setShowSpinButton(false);
    setDisabled(true);

    try {
      const response = await axios.post(
        `${api_url}game/direction-and-win`,
        {
          userId: profileData?._id,
          chosenDirection: selectedDirection,
          betAmount: amount,
        },
        {
          headers: {
            accesstoken: sessionStorage.getItem("accesstoken"),
          },
        }
      );

      const resData = response.data;

      if (!resData.success) {
        toast.error(resData.message || "Something went wrong!");
        // setDisabled(false);
        return;
      }

      const { spunDirection, outcome, winAmount, balance, success, didWin } =
        resData;

      if (success) {
        const prizeIndex = getPrizeIndexFromDirection(spunDirection);
        console.log("Backend says:", spunDirection, "-> Index:", prizeIndex);

        setWalletBalance(balance);
        setPrizeNumber(prizeIndex);
        setDidWin(didWin);
        setResultData({
          status: outcome === "win" ? "win" : "lose",
          rolled: spunDirection,
          winAmount,
        });

        setIsSpinning(true); // just before spinning
        handleSpin(prizeIndex);
      } else {
        toast.error("Spin failed. Please try again.");
      }
    } catch (error) {
      setLoadingResult(false); // hide loader on error
      console.error(error);
      toast.error(
        error?.response?.data?.message ||
          "An error occurred during the dice roll."
      );
      toast.error("Server error. Please try again.");
      setDisabled(false);
    } finally {
      setLoadingResult(false); // hide loader after response
    }
  };

  const handleResult = () => {
    if (!isSpinning) return; // skip if not spinning

    setIsSpinning(false); // spinning complete

    // Wait 2 seconds before showing result
    setTimeout(() => {
      if (resultData?.status === "win") fireConfetti();
      setRotationDeg(0); // Reset needle to North

      setOpenDialog(true);
    }, 3000);
  };

  const fireConfetti = () => {
    const duration = 5000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 1000,
    };

    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) return clearInterval(interval);

      confetti({
        ...defaults,
        particleCount: 50,
        origin: {
          x: randomInRange(0.1, 0.9),
          y: Math.random() - 0.2,
        },
      });
    }, 200);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${api_url}auth/get-auto-game-settings`, {
          headers: {
            accessToken: sessionStorage.getItem("accesstoken"),
          },
        });

        const data = res.data.data;

        const newSettings = {
          dice: { forcedWinCycleCount: 0, winningRatio: 0 },
          spin: { forcedWinCycleCount: 0, winningRatio: 0 },
          direction: { forcedWinCycleCount: 0, winningRatio: 0 },
        };

        data.forEach((s) => {
          if (s.key === "dice") {
            newSettings.dice = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
          } else if (s.key === "spin") {
            newSettings.spin = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
          } else if (s.key === "direction") {
            newSettings.direction = {
              forcedWinCycleCount: s.forcedWinCycleCount,
              winningRatio: s.winningRatio,
            };
            setDirectionMinute(s.minutes);
          }
        });

        setGameSettings(newSettings);
      } catch (err) {
        console.error("Failed to load auto game settings", err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      pingGameSession("direction-wheel-game");
    }, 2 * 60 * 1000); // every 2 mins

    return () => clearInterval(interval);
  }, []);

  console.log("minute", directionMinute);

  useEffect(() => {
    startDiceTimer();
    return () => clearTimeout(directionTimerId);
  }, []); // runs only once on mount

  function startDiceTimer() {
    const delay = (directionMinute || 5) * 60 * 1000;
    const now = Date.now();

    // If timer already started, compute remaining
    if (directionTimerStartedAt) {
      const elapsed = now - directionTimerStartedAt;
      const remaining = delay - elapsed;

      if (remaining > 0) {
        console.log(`⏱️ Resuming dice timer with ${remaining / 1000}s left`);
        const timeoutId = setTimeout(callUpdateCycle, remaining);
        setDirectionTimerId(timeoutId);
        return;
      }
    }

    console.log(
      `⏱️ Starting new dice cycle timer for ${delay / 60000} minutes`
    );
    const timeoutId = setTimeout(callUpdateCycle, delay);
    setDirectionTimerId(timeoutId);
    setDirectionTimerStartedAt(now);
  }

  async function callUpdateCycle() {
    try {
      console.log("⏰ Timer reached! Calling update-dice-cycle API...");
      await axios.put(
        `${api_url}game/update-direction-cycle`,
        {
          userId: profileData?._id,
          deviceId,
          sessionToken,
        },
        {
          headers: { accesstoken: sessionStorage.getItem("accesstoken") },
        }
      );
      console.log("✅ update-dice-cycle API called successfully");

      // 🔁 Restart timer for next cycle automatically
      setDirectionTimerStartedAt(Date.now());
      startDiceTimer();
    } catch (error) {
      console.error("❌ Error calling update-dice-cycle API:", error);
    }
  }

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <ArrowBackIcon
          sx={{
            color: { xs: "#1e2466", md: "#fff" },
            border: "1px solid #fff",
            backgroundColor: { xs: "#fff", md: "transparent" },
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "#1e2466",
              color: "#ffffff",
            },
            cursor: "pointer",
          }}
          onClick={async () => {
            try {
              await axios.post(
                `${api_url}game/extra-game/end-session`,
                {
                  gameId: "direction-wheel-game",
                  deviceId: getDeviceId(),
                  sessionToken: sessionStorage.getItem("sessionId"),
                },
                {
                  headers: {
                    accesstoken: sessionStorage.getItem("accesstoken"),
                  },
                }
              );

              // After session ends, navigate back
              navigate("/home/menus");
            } catch (err) {
              console.error("Failed to end session on back", err);
              navigate("/home/menus"); // Fallback navigation
            }
          }}
        />
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "20px", md: "24px" },
            ml: 1,
            color: "#fff",
          }}
        >
          Direction Wheel [ 1 : {gameSettings.direction.winningRatio} ]
        </Typography>
      </Box>

      <Box>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={8} sm={6} md={3}>
            <TextField
              select
              label="Choose Direction"
              value={selectedDirection}
              onChange={(e) => setSelectedDirection(e.target.value)}
              variant="outlined"
              fullWidth
              SelectProps={{
                native: true,
                sx: {
                  color: "black",
                  pointerEvents: isSpinning ? "none" : "auto",
                },
              }}
              size="small"
              sx={{
                maxWidth: { xs: 250, sm: 250 },
                "& .MuiInputBase-root": {
                  height: { xs: 50, sm: 60 },
                  color: "#FFD80A",
                  background: "rgba(255, 255, 255, 0.1)",
                  borderRadius: 1,
                  fontSize: { xs: "1.3rem", sm: "1.5rem" },
                  textAlign: "center",
                  fontWeight: "bolder",
                },
                "& .MuiInputLabel-root": { color: "#FFD80A" },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FFD80A",
                },
                "& option": { color: "#000", fontSize: "0.9rem" },
                "& .MuiInputBase-input": { textAlign: "center" },
              }}
              InputProps={{ readOnly: isSpinning }}
              disabled={disabled}
              InputLabelProps={{ shrink: true }}
            >
              {/* <option value="">-- Select Direction --</option> */}
              {directions.map((dir, index) => (
                <option key={index} value={dir}>
                  {dir}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4} sm={6} md={3}>
            <TextField
              label="Amount"
              value={amount}
              variant="outlined"
              type="number"
              fullWidth
              size="small"
              inputProps={{ min: 0 }}
              sx={{
                maxWidth: { xs: 100, sm: 150 },
                "& .MuiInputBase-root": {
                  height: { xs: 50, sm: 60 },
                  color: "#FFD80A",
                  background: "rgba(255, 255, 255, 0.1)",
                  borderRadius: 1,
                  fontSize: { xs: "1.5rem", sm: "2rem" },
                  textAlign: "center",
                  fontWeight: "bolder",
                },
                "& .MuiInputLabel-root": { color: "#FFD80A" },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FFD80A",
                },
                "& .MuiInputBase-input": { textAlign: "center" },
              }}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          display: { xs: "column", sm: "flex" },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Compass with CSS styling */}
        <Box
          sx={{
            position: "relative",
            width: circleSize,
            height: circleSize,
            // margin: "auto",
            my: 5,
            borderRadius: "50%",
            border: "4px solid #ffc400",
            background: "#004d40",
            overflow: "hidden",
            padding: paddingValue, // <-- add this
            boxSizing: "border-box", // ensures padding doesn't stretch size
          }}
        >
          {/* Divider Lines */}
          {directions.map((_, i) => {
            const angle = (360 / directions.length) * i;
            return (
              <Box
                key={`divider-${i}`}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "1px",
                  height: `${radius}px`, // dynamic based on size
                  backgroundColor: "#ffc400",
                  transform: `rotate(${angle}deg) translateY(-50%)`,
                  transformOrigin: "top center",
                  zIndex: 2,
                  opacity: 0.8,
                }}
              />
            );
          })}

          {/* Needle */}
          <Box
            sx={{
              position: "absolute",
              top: "25%",
              left: "25%",
              width: "50%",
              height: "50%",
              clipPath: "polygon(50% 0%, 60% 50%, 50% 100%, 40% 50%)",
              background: "linear-gradient(to bottom, red, #333)",
              transform: `rotate(${rotationDeg}deg)`,
              transformOrigin: "center",
              transition: "transform 2s ease-out",
              zIndex: 4,
            }}
            onTransitionEnd={handleResult}
          />

          {/* Center Hub */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: circleSize * 0.05, // ~5% of total
              height: circleSize * 0.05,
              transform: "translate(-50%, -50%)",
              background: "radial-gradient(circle, #ffc400, #ff6f00)",
              borderRadius: "50%",
              zIndex: 5,
              boxShadow: "0 0 10px rgba(255, 255, 0, 0.7)",
            }}
          />

          {/* Labels */}
          {directions.map((dir, i) => {
            const angle = (360 / directions.length) * i;

            const center = circleSize / 2;

            // Margin from the outer edge (relative to size)
            const labelOffset = circleSize * 0.1; // ~10% inside from the edge

            const labelRadius = center - labelOffset;

            const x =
              center + labelRadius * Math.cos((angle - 90) * (Math.PI / 180));
            const y =
              center + labelRadius * Math.sin((angle - 90) * (Math.PI / 180));

            return (
              <Box
                key={dir}
                sx={{
                  position: "absolute",
                  top: y,
                  left: x,
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  fontSize: circleSize * 0.04, // Responsive font size (~13.5px on 450)
                  px: circleSize * 0.025, // Padding scales
                  py: 0.3,
                  borderRadius: "6px",
                  color: labelColors[i % labelColors.length],
                  zIndex: 3,
                  pointerEvents: "none",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "transparent",
                }}
              >
                {dir}
              </Box>
            );
          })}
        </Box>

        <Box>
          {showSpinButton && (
            <Box
              component="img"
              src="/auto-games/rtc.webp"
              alt="Spin"
              sx={{
                width: { xs: 200, sm: 240 },
                height: "auto",
                cursor: disabled ? "not-allowed" : "pointer",
                pointerEvents: disabled ? "none" : "auto",
                opacity: disabled ? 0.5 : 1,
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  transform: disabled ? "none" : "scale(1.05)",
                },
                ml: { xs: 0, sm: 2 },
                mt: { xs: 4, sm: 2 },
              }}
              onClick={handleSpinClick}
            />
          )}
        </Box>
      </Box>

      {/* Dialog */}
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: "linear-gradient(90deg,rgb(94, 15, 151), #9b30ff)",
            boxShadow: 10,
            border: `6px solid #4b0082`,
          },
        }}
      >
        {loadingResult ? (
          // Show loader while waiting
          <Box
            sx={{
              py: 6,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress color="warning" size={60} thickness={5} />
            <Typography
              sx={{
                mt: 3,
                fontSize: "1.1rem",
                fontWeight: "bold",
                color: "#fff",
              }}
            >
              Rolling the dice...
            </Typography>
          </Box>
        ) : (
          <>
            {" "}
            <Fade in={openDialog} timeout={500}>
              <DialogTitle
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 0,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                      mb: 3,
                    }}
                  >
                    <Grow in={openDialog} timeout={600}>
                      <Box
                        sx={{
                          height: { xs: "80px", sm: "100px" },
                          width: "150px",
                        }}
                      >
                        <img
                          src={
                            didWin
                              ? "/auto-games/win.webp"
                              : "/auto-games/betterluck.webp"
                          }
                          alt="Direction Result"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </Box>
                    </Grow>
                  </Box>
                </Box>
              </DialogTitle>
            </Fade>
            {/* Rolled directions comparison */}
            <DialogContent sx={{ p: 0, textAlign: "center" }}>
              <Grid container spacing={2}>
                {[selectedDirection, resultData?.rolled].map((value, index) => (
                  <Grid item xs={6} key={index}>
                    <Grow in={openDialog} timeout={700 + index * 150}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mb: 3,
                        }}
                      >
                        <Box sx={{ width: "70px" }}>
                          <img
                            src={
                              index === 0 ? "/selected.png" : "/totalscore.png"
                            }
                            alt={index === 0 ? "Selected" : "Result"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            mt: 2,
                            width: 80,
                            height: 80,
                            background:
                              // index === 0
                              //   ? "linear-gradient(45deg,rgb(179, 12, 179), #ff4d4d)"
                              //   : selectedDirection === resultData?.rolled
                              //   ? "linear-gradient(45deg,rgb(13, 61, 27),rgb(10, 112, 49))"
                              //   :
                              "linear-gradient(45deg, #ff4d4d,rgb(163, 16, 163))",
                            borderRadius: "50%",
                            color: "white",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1.1rem",
                            boxShadow: 3,
                          }}
                        >
                          {value}
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>

              {/* Win/Loss message */}
              <Grow in={openDialog} timeout={1000}>
                <Button
                  variant="outlined"
                  align="center"
                  sx={{
                    mx: { xs: 5, sm: 10 },
                    mt: 2,
                    fontWeight: "bolder",
                    letterSpacing: 0.5,
                    color: "#fff",
                    borderColor: "#fff",
                    background: didWin
                      ? "linear-gradient(90deg, #7b68ee, #9b30ff)"
                      : "linear-gradient(90deg, #ff4d4d, #800080)",
                    "&:hover": {
                      opacity: 0.85,
                      background: didWin
                        ? "linear-gradient(90deg, #7b68ee, #a64dff)"
                        : "linear-gradient(90deg, #ff6666, #9932cc)",
                    },
                  }}
                >
                  {didWin ? (
                    <>
                      You earned{" "}
                      <Box
                        component="span"
                        sx={{
                          fontSize: "1.3rem",
                          fontWeight: "900",
                          background:
                            "linear-gradient(45deg, #00ff00, #00cc00)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          display: "inline-block",
                          mx: 1,
                        }}
                      >
                        {resultData?.winAmount}
                      </Box>
                      credits
                    </>
                  ) : (
                    <>
                      You lost{" "}
                      <Box
                        component="span"
                        sx={{ fontSize: "1.3rem", fontWeight: "900", mx: 1 }}
                      >
                        {amount}
                      </Box>
                      credits
                    </>
                  )}
                </Button>
              </Grow>
            </DialogContent>
            {/* Play Again / Try Again Button */}
            <DialogActions sx={{ px: 3, my: 3 }}>
              <Grow in={openDialog} timeout={1200}>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                    setDisabled(false);
                    setTimeout(() => {
                      setResultData(null);
                      setIsSpinning(false);
                      setRotationDeg(0);
                      setShowSpinButton(true); // restore spin button visibility
                    }, 300);
                  }}
                  fullWidth
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent",
                      opacity: 1,
                    },
                    backgroundColor: "transparent",
                  }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mb: 3 }}
                  >
                    <Box sx={{ width: "220px" }}>
                      <img
                        src={didWin ? "/playagain.png" : "/tryagain.png"}
                        alt="Try Again"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </Box>
                  </Box>
                </Button>
              </Grow>
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default DirectionWheelGame;
